<template>
  <div class="BaseTemplateItemSetting q-pa-md q-pa-lg-lg scroll hide-scrollbar">
    <template v-if="templateStore.activeItem.id">
      <BaseTemplateItemTextSetting v-if="templateStore.activeItem.type === 'text'" />
      <BaseTemplateItemImageSetting v-if="templateStore.activeItem.type === 'image'" />
      <BaseTemplateItemShapeSetting v-if="templateStore.activeItem.type === 'shape'" />
    </template>
  </div>
</template>

<script setup>
import { useTemplateStore } from 'src/stores'
import BaseTemplateItemTextSetting from './BaseTemplateItemTextSetting.vue'
import BaseTemplateItemImageSetting from './BaseTemplateItemImageSetting.vue'
import BaseTemplateItemShapeSetting from './BaseTemplateItemShapeSetting.vue'

defineOptions({ name: 'BaseTemplateItemSetting' })

const templateStore = useTemplateStore()
</script>
